export const SORT_BY = {
  mostRecent: 'DateOpen',
  closingSoon: 'DateClose',
};

export const PROJECT_STATUS = {
  open: 'open',
  closed: 'closed',
  allOpportunities: 'open,closed',
};

export const PROJECT_SOURCE = {
  bonfire: 'bonfire',
  external: 'external',
  allSources: 'bonfire,external',
};
export const BONFIRE_OPPORTUNITY_TYPES = [
  'RFP',
  'RFSQ',
  'RFPQ',
  'RFQ',
  'RFI',
  'EOI',
  'RFS',
  'RFC',
  'RFT',
  'SOW',
  'RFB',
  'RSO',
  'ITB',
  'ITPQ',
  'ITQ',
  'ITT',
  'ITN',
  'IFB',
  'CSP',
  'NRFP',
  'RFA',
  'ACAN',
  'SS',
  'BI',
  'NOA',
  'NOI',
  'Other',
];
